var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYourWebsiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5984 16.5004C27.5984 16.7821 27.5884 17.0615 27.5686 17.3382C27.2095 22.3701 23.6408 26.5143 18.8984 27.7349C17.9715 27.9735 16.9998 28.1004 15.9984 28.1004C14.9971 28.1004 14.0253 27.9735 13.0984 27.7349C8.35604 26.5143 4.78735 22.3701 4.42823 17.3382C4.40848 17.0615 4.39844 16.7821 4.39844 16.5004M27.5984 16.5004C27.5984 16.2187 27.5884 15.9393 27.5686 15.6626C27.2095 10.6307 23.6408 6.48645 18.8984 5.26584C17.9715 5.02727 16.9998 4.90039 15.9984 4.90039C14.9971 4.90039 14.0253 5.02727 13.0984 5.26584C8.35604 6.48645 4.78735 10.6307 4.42823 15.6626C4.40848 15.9393 4.39844 16.2187 4.39844 16.5004M27.5984 16.5004H20.5095M4.39844 16.5004H11.4873M20.5095 16.5004C20.5095 12.6337 19.4657 8.45796 15.9984 6.45226C12.5312 8.45796 11.4873 12.6337 11.4873 16.5004M20.5095 16.5004C20.5095 20.3671 19.4657 24.5428 15.9984 26.5485C12.5312 24.5428 11.4873 20.3671 11.4873 16.5004M20.5095 16.5004H11.4873",
    stroke: "#1570EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourWebsiteIcon);
export default __webpack_public_path__ + "d1ad8a13f319214f182c63b51b3e03b4.svg";
export { ForwardRef as ReactComponent };